import { render, staticRenderFns } from "./combo.vue?vue&type=template&id=35752734"
import script from "./combo.ts?vue&type=script&lang=js&external"
export * from "./combo.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35752734')) {
      api.createRecord('35752734', component.options)
    } else {
      api.reload('35752734', component.options)
    }
    module.hot.accept("./combo.vue?vue&type=template&id=35752734", function () {
      api.rerender('35752734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/combo.vue"
export default component.exports